/* eslint-disable react-hooks/exhaustive-deps */
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import dynamic from "next/dynamic"
import { useRouter } from "next/router"
import { useMemo, ChangeEvent, useState, useEffect } from "react"
import { PageType } from "../../../../pages/_app"
import { useLayoutData } from "../../../../utils/contexts/LayoutContext"
import { filterUrl } from "../Find"
import { FindCheckboxCheckedIconProps } from "../FindDesignTypes"
import { FilterBaseProps } from "../Find.types"

const FilterCheckBoxList = ({
	filters,
	pageUrl,
	mmbr,
	colors,
	isMobile
}: FilterBaseProps) => {
	const router = useRouter()
  const { partnerSiteFull, templatePath } = useLayoutData()

	const [list, setList] = useState<string[] | undefined>()

  const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath

  const FindCheckboxIcon = useMemo(() => dynamic(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindCheckboxIcon)), [path])
  const FindCheckboxCheckedIcon = useMemo(() => dynamic<FindCheckboxCheckedIconProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindCheckboxCheckedIcon)), [path])

  const handleChecked = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
			setList((prevList) => prevList ? [...prevList, e.target.value] : [e.target.value])
    } else {
			setList((prevList) => prevList ? prevList.filter((item) => item !== e.target.value) : undefined)
    }
  }

	useEffect(() => {
		setList(filters.items?.filter((item) => item.selected)?.map((item) => item.targetUrlListItem as string) ?? [])
	}, [filters])

	useEffect(() => {
		if (list) {
			const url = filters.targetUrl?.replace('(list)', list.join(','))
			router.push(list.length > 0 ? filterUrl(filters, undefined, url, pageUrl, mmbr) : filters.resetUrl as string, undefined, { scroll: false })
		}
	}, [list])

  return (
		<FormGroup sx={{ p: isMobile ? 2 : undefined}}>
			{filters.items?.map((item, i) => (
				<FormControlLabel
					key={i}
					control={
						<Checkbox
							sx={{ p: 0, pr: 1 }}
							disableRipple
							checkedIcon={<FindCheckboxCheckedIcon checkedcolor={colors.mainColor} />}
							icon={<FindCheckboxIcon />}
							value={item.targetUrlListItem ?? ''}
							onChange={handleChecked}
							checked={item.selected ?? false}
							disabled={item.disabled ?? false}
						/>
					}
					label={item.title}
					sx={{ mb: 1 }}
				/>
			))}
		</FormGroup>
  )
}

export default FilterCheckBoxList